// Consulta o ViaCEP fora do axios global: os defaults dele levariam o token do
// usuário (Authorization) a um serviço de terceiros e forçariam um preflight CORS.
// Sem headers próprios, vira uma requisição simples. Mantém o formato do axios:
// resolve com { data, status } e rejeita em falha de rede ou status fora de 2xx.
export async function buscaCepViaCep(cep) {
  const response = await fetch(
    `https://viacep.com.br/ws/${encodeURIComponent(cep)}/json`,
    { credentials: "omit" }
  );
  const text = await response.text();
  let data = text;
  try {
    data = JSON.parse(text);
  } catch (error) {
    // Como o axios: corpo que não é JSON segue como texto.
  }

  if (!response.ok) {
    const error = new Error(`ViaCEP respondeu ${response.status}`);
    error.response = { status: response.status, data };
    throw error;
  }
  return { data, status: response.status };
}
